/**
 * 技术性能埋点统一上报（ARMS custom event，group = performance）
 */

import { reportCustomEvent } from '@/utils/arms';

import type { EPerformanceEvents } from './events';

export function reportPerformanceEvent(event: EPerformanceEvents, properties: Record<string, unknown>): void {
    reportCustomEvent(event, 'performance', { properties });
}
